/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import {
  bus
} from '../../main';
import toast from '../../services/toast';

export default {
  name: 'delete-courses',
  components: {},
  data() {
    return {
      courses: {},
      courseListResults: [],
      categoryList: {},
      categoryFilterName: 'Select Category',
      id: '',
      loader: true,
      deleteCourseId: ''
    }
  },
  computed: {
    ...mapGetters([
      'trashCoursesState',
      'getCategoryListState',
      'getCourseByCategoryState',
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryListState;
      return this.categoryList
    },
    getAllCourses() {
      this.$store.dispatch('trashCourselist')
        .then((res) => {
          if (res.data.code == '2000') {
            this.loader = false;
            // debugger
            return this.courses = this.$store.getters.trashCoursesState.data
          }
        })
        .catch((err) => {})
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results

      }
    }
  },
  mounted() {
    this.getCategory
    this.getAllCourses
    this.SetIntialStatus
  },
  methods: {
    getCourseDetailsAgain() {
      this.loader = true;
      this.$store.dispatch('trashCourselist').then((res) => {
        if (res.data.code == '2000') {
          this.loader = false;
          return this.courses = this.$store.getters.trashCoursesState.data
        }
      }).catch((err) => {})
    },
    viewCourseDetailsFun(id) {
      this.$router.push('/course/' + id + "/tab/")
      return this.courses = this.$store.getters.trashCoursesState.data;
    },
    getCoursebyCategory(id, name) {
      this.loader = true;
      if (id != "") {
        this.$router.push('/usercourses/category/' + id + "/")
      } else {
        this.$router.push('/courses/')
        this.loader = false;
      }
      this.categoryFilterName = name;
    },
    deleteCourseFun(id) {
      this.deleteCourseId = id
      $('#removeCourseModal').modal()
    },
    removeCourseModalConfirmation() {
      this.submitted = true;
      let data = {
        is_deleted: false,
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id:  this.deleteCourseId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Restore Successfully");
        }
      }).catch((err) => {})
      return
    }
  },
  beforeMount() {
    this.getAllCourses
  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoryListState
    },
    getAllCourses() {
      return this.$store.getters.trashCoursesState;
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.courseListResults = this.courses.results
      }
    }
  }
}